import styled from "styled-components";

import loaderImg from "../../assets/gifs/loader.gif";

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100vh;
  width: 100vw;
`;

export const LoaderImg = styled.div`
  background-image: url("${loaderImg}");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  width: 100px;
  height: 100px;
  @media (max-width: 800px) {
    width: 60px;
    height: 60px;
  }
`;

export const BlockBox = styled.div`
  height: 64px;
  @media (max-width: 800px) {
    height: 60px;
    margin-top: 30px;
  }
`;
